import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import FormSelect from 'react-bootstrap/FormSelect';
import FormLabel from 'react-bootstrap/FormLabel';
import number_1 from '../images/number-1.png';
import number_2 from '../images/number-2.png';
import number_3 from '../images/number-3.png';
import google_icon from '../images/adwords.png';
import facebook_icon from '../images/facebook.png';
import connected_icon from '../images/correct.png';
import axios from 'axios';
import Cookies from 'js-cookie';
import {showToast as toast} from '../toastManager';
import Settings from './Settings';

// Hidden pending Google approvals — flip back to true to restore the Drive
// tile and its status polling. Server routes stay live either way.
const SHOW_DRIVE_INTEGRATION = false;

function Home({ViewedPage, shop_domain, app_url, isInSettingsContainer = false, usePopup = false, onPopupOpen}) {
    const navigate = useNavigate();
    if (!isInSettingsContainer) {
        navigate('/settings', { state: { default_tab: 'google-meta-integration' } });
    }

    // Render Select Ads Account and conversion action setting
    const [show_google_login_btn, setShowGoogleLogin] = useState(true);
    const [show_facebook_login_btn, setShowFacebookLogin] = useState(true);
    const [Step1Indicator, setStep1Indicator] = useState(!show_google_login_btn);
    const [Step2Indicator, setStep2Indicator] = useState(false);
    const [google_loading, setGoogleLoading] = useState(true);
    const [facebook_loading, setFacebookLoading] = useState(true);

    // Google ad account selection
    const [google_ads_account_select_dict, setGoogleAdsAccountSelectDict] = useState([]);
    const [google_selected_account, setGoogleSelectedAccount] = useState("");

    // Facebook ad account selection
    const [facebook_ads_account_select_dict, setFacebookAdsAccountSelectDict] = useState([]);
    const [facebook_ads_acc_pixel_json, setFacebookAdsAccPixelJson] = useState({});
    const [facebook_selected_ads_account, setFacebookSelectedAccount] = useState(null);
    const [facebook_selected_ads_account_pixel, setFacebookSelectedAccountPixel] = useState(null);
    const [facebook_all_account_details, setAllFBAccountDetails] = useState({});

    // Current dropdown selection vs last-saved selection — drives the disabled
    // state of the "Select" buttons (disabled until the selection changes).
    const [google_account_choice, setGoogleAccountChoice] = useState("");
    const [facebook_saved_ads_account, setFacebookSavedAccount] = useState(null);
    const [facebook_saved_ads_account_pixel, setFacebookSavedPixel] = useState(null);

    // Google Drive linking (self-contained OAuth — see server/google/drive_integration.js)
    const [drive_loading, setDriveLoading] = useState(true);
    const [drive_connected, setDriveConnected] = useState(false);
    const [drive_email, setDriveEmail] = useState(null);

    const fetchDriveStatus = () => {
        if (!Cookies.get('shop')) return;
        axios.post(app_url + "/api/google/drive_status", {
            shop_domain: Cookies.get('shop')
        }, { withCredentials: true })
        .then(res => res.data)
        .then(data => {
            if (data.success) {
                setDriveConnected(!!data.connected);
                setDriveEmail(data.email || null);
            }
            setDriveLoading(false);
        })
        .catch(() => setDriveLoading(false));
    };

    const handle_sign_out = async (e) => {
        e.preventDefault();
        setGoogleLoading(true);
        try {
            if(Cookies.get('shop')){
                const { data } = await axios.post(app_url+"/api/google/sign_out",{
                    shop_domain:Cookies.get('shop')
                }, {withCredentials:true});
                if(data.success){
                    toast.success(data.message);
                    setGoogleLoading(false);
                    setShowGoogleLogin(true);
                    setStep1Indicator(false);
                    setStep2Indicator(false);
                    localStorage.setItem('scalex_auth_changed', Date.now().toString());
                }
                else{
                    setGoogleLoading(false);
                    toast.error(data.message);
                }
            }
        } catch (error) {
            setGoogleLoading(false);
            toast.error("Please try again.");
        }
    };

    const handle_facebook_sign_out = async (e) => {
        e.preventDefault();
        setFacebookLoading(true);
        try {
            if(Cookies.get('shop')){
                const { data } = await axios.post(app_url+"/api/facebook/sign_out",{
                    shop_domain:Cookies.get('shop')
                }, {withCredentials:true});
                if(data.success){
                    toast.success(data.message);
                    setFacebookLoading(false);
                    setShowFacebookLogin(true);
                    setStep1Indicator(false);
                    setStep2Indicator(false);
                    localStorage.setItem('scalex_auth_changed', Date.now().toString());
                }
                else{
                    setFacebookLoading(false);
                    toast.error(data.message);
                }
            }
        } catch (error) {
            setFacebookLoading(false);
            toast.error("Please try again.");
        }
    };

    const handle_drive_sign_in = () => {
        // Open the popup synchronously (inside the click gesture) so blockers
        // allow it, then point it at Google once the server mints the URL. The
        // callback page closes itself; polling popup.closed refreshes status.
        const popup = window.open('about:blank', 'oauth_popup', 'width=600,height=700,left=200,top=100');
        if (!popup) {
            toast.error("Please allow popups to connect Google Drive.");
            return;
        }
        axios.post(app_url + "/api/google/drive_sign_in", {
            shop_domain: shop_domain.replace(".myshopify.com", ""),
        }, { withCredentials: true })
        .then((response) => response.data)
        .then((data) => {
            popup.location.href = data["data"]["redirect_url"];
            if (onPopupOpen) onPopupOpen(popup);
            const timer = setInterval(() => {
                if (popup.closed) {
                    clearInterval(timer);
                    setDriveLoading(true);
                    fetchDriveStatus();
                }
            }, 600);
        })
        .catch((error) => {
            popup.close();
            toast.error("Please try again.");
        });
    };

    const handle_drive_sign_out = async (e) => {
        e.preventDefault();
        setDriveLoading(true);
        try {
            const { data } = await axios.post(app_url + "/api/google/drive_sign_out", {
                shop_domain: Cookies.get('shop')
            }, { withCredentials: true });
            if (data.success) {
                toast.success(data.message);
                setDriveConnected(false);
                setDriveEmail(null);
                setDriveLoading(false);
                localStorage.setItem('scalex_auth_changed', Date.now().toString());
            } else {
                setDriveLoading(false);
                toast.error(data.message);
            }
        } catch (error) {
            setDriveLoading(false);
            toast.error("Please try again.");
        }
    };

    const handle_change_ads_account = async (e) => {
        e.preventDefault();
        try {
            if (Cookies.get('shop')) {
                var ad_account = document.getElementById("ads_account_select").value;
                const { data } = await axios.post(app_url + "/api/google/change_ads_account", {
                    shop_domain: Cookies.get('shop'),
                    ads_account: ad_account
                }, { withCredentials: true });
                if (data.success) {
                    toast.success(data.message);
                    setGoogleSelectedAccount(ad_account);
                } else {
                    toast.error(data.message);
                }
            }
        } catch (error) {
            toast.error("Please try again.");
        }
    };

    const handleFacebookSelectAccount = async (e) => {
        e.preventDefault();
        try {
            if (Cookies.get('shop')) {
                var ad_account = document.getElementById("facebook_ads_account_select").value;
                var pixel_id = document.getElementById("ads_account_pixel_select").value;
                const { data } = await axios.post(app_url + "/api/facebook/change_ads_account", {
                    shop_domain: Cookies.get('shop'),
                    ads_account: ad_account,
                    pixel_id: pixel_id
                }, { withCredentials: true });
                if (data.success) {
                    toast.success(data.message);
                    setFacebookSelectedAccount(ad_account);
                    setFacebookSelectedAccountPixel(pixel_id);
                    setFacebookSavedAccount(ad_account);
                    setFacebookSavedPixel(pixel_id);
                    if (facebook_all_account_details?.[ad_account]) {
                        facebook_all_account_details[ad_account]["selected_pixel_id"] = pixel_id;
                        setAllFBAccountDetails({ ...facebook_all_account_details });
                    }
                } else {
                    toast.error(data.message);
                }
            }
        } catch (error) {
            toast.error("Please try again.");
        }
    };

    useEffect(() => {
        const shopDomain = Cookies.get('shop');
        if (!shopDomain) return;

        const fetchData = (resetState = true) => {
            if (resetState) {
                setShowGoogleLogin(true);
                setShowFacebookLogin(true);
            }
            axios.post(app_url + "/api/facebook_and_google/get_home_loader_data", {
                shop_domain: shopDomain
            }, { withCredentials: true })
            .then(res => res.data)
            .then(data => {
                if (data.success) {
                    // Google
                    const googleData = data.data.google;
                    setShowGoogleLogin(googleData.show_google_login_btn);
                    setStep1Indicator(!googleData.show_google_login_btn);
                    setGoogleAdsAccountSelectDict(
                        (googleData.account_list || []).map(acc => ({ label: acc, value: acc.split(" - ")[0] }))
                    );
                    setGoogleSelectedAccount(googleData.selected_account || "");
                    setGoogleLoading(false);

                    // Facebook
                    const fbData = data.data.facebook;
                    setShowFacebookLogin(fbData.is_show_continue_with_facebook_btn);
                    setStep2Indicator(!fbData.is_show_continue_with_facebook_btn);
                    const temp_ads_acc_pixel_json = {};
                    (fbData.ads_acc_pixel_json || []).forEach(acc => {
                        temp_ads_acc_pixel_json[acc["id"]] = (acc["pixel_id"] || []).map(p => ({
                            label: p["id"] + " - " + p["name"], value: p["id"]
                        }));
                    });
                    setFacebookAdsAccPixelJson(temp_ads_acc_pixel_json);
                    setFacebookAdsAccountSelectDict(
                        (fbData.ads_acc_pixel_json || []).map(acc => ({
                            label: acc["id"] + " - " + acc["name"], value: acc["id"]
                        }))
                    );
                    setAllFBAccountDetails(fbData.all_account_details || {});
                    setFacebookSelectedAccount(fbData.selected_ads_account || null);
                    setFacebookSelectedAccountPixel(fbData.selected_ads_account_pixel || null);
                    setFacebookSavedAccount(fbData.selected_ads_account || null);
                    setFacebookSavedPixel(fbData.selected_ads_account_pixel || null);
                    setFacebookLoading(false);
                }
            })
            .catch(error => {
                setGoogleLoading(false);
                setFacebookLoading(false);
                toast.error(error?.response?.data?.message || "Something went wrong. Please try again.");
            });
        };

        fetchData();
        if (SHOW_DRIVE_INTEGRATION) fetchDriveStatus();

        const onAuthChanged = (e) => {
            if (e.key === 'scalex_auth_changed') { fetchData(false); if (SHOW_DRIVE_INTEGRATION) fetchDriveStatus(); }
        };
        window.addEventListener('storage', onAuthChanged);
        return () => window.removeEventListener('storage', onAuthChanged);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [app_url, shop_domain]);

    // Keep the Google account dropdown's current choice in sync with the saved
    // account (loader / after a save) so the Select button re-disables once saved.
    useEffect(() => {
        setGoogleAccountChoice(google_selected_account || google_ads_account_select_dict[0]?.value || "");
    }, [google_selected_account, google_ads_account_select_dict]);

    // The "Select" buttons stay disabled until the current dropdown selection
    // differs from what was last saved.
    const googleSelectionUnchanged = google_account_choice === google_selected_account;
    const facebookSelectionUnchanged =
        facebook_selected_ads_account === facebook_saved_ads_account &&
        facebook_selected_ads_account_pixel === facebook_saved_ads_account_pixel;

    return (
        <div className='main-container' style={{position:"relative"}}>
            {!shop_domain?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display:'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    { ((google_loading !== true) && (facebook_loading !== true)) ?
                        <>
                        {!isInSettingsContainer && (
                            <div className='main-title mt-4'>
                                <h2>Integrations</h2>
                            </div>
                        )}
                        <div className='integration-main-accordion-body main-accordion-body mt-4 p-2'>
                        <Accordion defaultActiveKey={ ["0","1","2"]} alwaysOpen>
                            {/* Step - 1 (Google Ads Integration) */}
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className='google-ads-accordion-button'>
                                    <img src={number_1} alt='1' width={"15px"} height={"15px"} /> 
                                    <b style={{marginLeft:"10px"}}>Integrate Google Ads</b> 
                                    {/* { Step1Indicator && <img alt='connected' style={{padding:"6px", marginRight:"10px"}} src={connected_icon} width={"30px"}/> } */}
                                </Accordion.Header>
                                <Accordion.Body className='pt-2'>
                                    <Container className='google_and_meta_integration_accordion_container'>
                                        <Row className='mt-3'>
                                            {show_google_login_btn === true && <Col className='d-flex align-items-center' sm={8}>Connect Google Ads Account to get started.</Col>}
                                            <Col sm={4} className='google_and_meta_integration_status_col text-end'>
                                            { show_google_login_btn === true &&
                                                <button style={{backgroundColor:'var(--cux-btn, rgb(19, 40, 72))', color:"white", width:"8rem",border:"none","padding": "2px 10px 2px 2px","cursor":" pointer", display:"flex", alignItems:"center"}} onClick={() => {
                                                    setGoogleLoading(true);
                                                    axios.post(app_url+"/api/google/google_sign_in",{
                                                        "shop_domain":shop_domain.replace(".myshopify.com",""),
                                                    }, {withCredentials:true})
                                                    .then((response) => response.data)
                                                    .then((data) => {
                                                        setGoogleLoading(false);
                                                        const url = data["data"]["redirect_url"];
                                                        if (usePopup) {
                                                            const popup = window.open(url, "oauth_popup", "width=600,height=700,left=200,top=100");
                                                            if (onPopupOpen) onPopupOpen(popup);
                                                        } else {
                                                            window.location.href = url;
                                                        }
                                                    })
                                                    .catch((error) => {
                                                        setGoogleLoading(false);
                                                        toast.error("Please try again.")
                                                    });
                                                }}>
                                                <img style={{background:"white", padding:"6px", marginRight:"10px"}} alt='Google Ads' src={google_icon} width={"30px"}/> 
                                                <h6 style={{margin:"auto"}}>
                                                    Sign In
                                                </h6>
                                                </button>
                                            }
                                            {/* { show_google_login_btn === false &&
                                                <button 
                                                className='back-button btn-height'
                                                onClick={handle_sign_out}
                                                >
                                                <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                </button>
                                            } */}
                                            </Col>
                                        </Row>
                                        { show_google_login_btn === false && google_ads_account_select_dict.length > 0 &&
                                            <Row>
                                                <Col sm={8}>
                                                    <FormLabel className="charts_filter_label" style={{marginBottom:"0px"}}>Select Ads Account</FormLabel>
                                                    <FormSelect value={google_account_choice} id="ads_account_select" onChange={(e) => setGoogleAccountChoice(e.target.value)}>
                                                        {google_ads_account_select_dict.map(acc => (
                                                            <option key={acc.value} value={acc.value}>{acc.label}</option>
                                                        ))}
                                                    </FormSelect>
                                                </Col>
                                                <Col sm={4} className="google_and_meta_integration_status_col d-flex align-items-end">
                                                    <button
                                                    className='sxi_primary_blue_btn btn-height'
                                                    style={{marginBottom: "2px", opacity: googleSelectionUnchanged ? 0.5 : 1, cursor: googleSelectionUnchanged ? 'not-allowed' : 'pointer'}}
                                                    disabled={googleSelectionUnchanged}
                                                    onClick={handle_change_ads_account}>
                                                        Select
                                                    </button>
                                                    <button
                                                    className='back-button btn-height mx-3'
                                                    onClick={handle_sign_out}
                                                    style={{marginBottom: "2px"}}
                                                    >
                                                    <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                    </button>
                                                </Col>
                                            </Row>
                                        }
                                        { show_google_login_btn === false && google_ads_account_select_dict.length === 0 &&
                                            <Row>
                                                <Col sm={8} className="d-flex align-items-center">
                                                    <span>No ads account found.</span>
                                                </Col>
                                                <Col sm={4} className="google_and_meta_integration_status_col">
                                                    <button
                                                    className='back-button btn-height'
                                                    onClick={handle_sign_out}
                                                    >
                                                    <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                    </button>
                                                </Col>
                                            </Row>
                                        }
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Step - 2 (Facebook Ads Integration) */}
                            <Accordion.Item eventKey="1">
                                <Accordion.Header className='google-ads-accordion-button'>
                                    <img src={number_2} alt='2' width={"15px"} height={"15px"} /> 
                                    <b style={{marginLeft:"10px"}}>Integrate Facebook Ads</b> 
                                    {/* { Step2Indicator && <img alt='connected' style={{padding:"6px", marginRight:"10px"}} src={connected_icon} width={"30px"}/> } */}
                                </Accordion.Header>
                                <Accordion.Body className='pt-2'>
                                    <Container className='google_and_meta_integration_accordion_container'>
                                        <Row className='mt-3'>
                                            {show_facebook_login_btn === true && <Col className='d-flex align-items-center' sm={8}>Connect Facebook Ads Account to get started.</Col>}
                                            <Col sm={4} className='google_and_meta_integration_status_col text-end'>
                                            { show_facebook_login_btn === true &&
                                                <button style={{backgroundColor:'var(--cux-btn, rgb(19, 40, 72))', color:"white", width:"8rem",border:"none","padding": "2px 10px 2px 2px","cursor":" pointer", display:"flex", alignItems:"center"}} onClick={() => {
                                                    setFacebookLoading(true);
                                                    axios.post(app_url+"/api/facebook/facebook_sign_in",{
                                                        "shop_domain":shop_domain.replace(".myshopify.com",""),
                                                    }, {withCredentials:true})
                                                    .then((response) => response.data)
                                                    .then((data) => {
                                                        setFacebookLoading(false);
                                                        const url = data["data"]["redirect_url"];
                                                        if (usePopup) {
                                                            const popup = window.open(url, "oauth_popup", "width=600,height=700,left=200,top=100");
                                                            if (onPopupOpen) onPopupOpen(popup);
                                                        } else {
                                                            window.location.href = url;
                                                        }
                                                    })
                                                    .catch((error) => {
                                                        setFacebookLoading(false);
                                                        toast.error("Please try again.")
                                                    });
                                                }}>
                                                    <img style={{background:"white", padding:"6px", marginRight:"10px"}} alt='Facebook Ads' src={facebook_icon} width={"30px"}/> 
                                                    <h6 style={{margin:"auto"}}>
                                                        Sign In
                                                    </h6>
                                                </button>
                                            }
                                            {/* { show_facebook_login_btn === false &&
                                                <button
                                                className='back-button btn-height' 
                                                onClick={handle_facebook_sign_out}
                                                >
                                                <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                </button>
                                            } */}
                                            </Col>
                                        </Row>
                                        { show_facebook_login_btn === false && facebook_ads_account_select_dict.length > 0 &&
                                            <Row>
                                                <Col sm={4}>
                                                    <FormLabel className="charts_filter_label" style={{marginBottom:"0px"}}>Select Ads Account</FormLabel>
                                                    <FormSelect value={facebook_selected_ads_account} id="facebook_ads_account_select" onChange={(e) => setFacebookSelectedAccount(e.target.value)}>
                                                        {facebook_ads_account_select_dict.map(acc => (
                                                            <option key={acc.value} value={acc.value}>{acc.label}</option>
                                                        ))}
                                                    </FormSelect>
                                                </Col>
                                                <Col sm={4}>
                                                    <FormLabel className="charts_filter_label" style={{marginBottom:"0px"}}>Select Pixel</FormLabel>
                                                    <FormSelect value={facebook_selected_ads_account_pixel} id="ads_account_pixel_select" onChange={(e) => setFacebookSelectedAccountPixel(e.target.value)}>
                                                        { (facebook_selected_ads_account && facebook_ads_acc_pixel_json[facebook_selected_ads_account]) ?
                                                            facebook_ads_acc_pixel_json[facebook_selected_ads_account].map(p => (
                                                                <option key={p.value} value={p.value}>{p.label}</option>
                                                            )) : null
                                                        }
                                                    </FormSelect>
                                                </Col>
                                                <Col sm={4} className="google_and_meta_integration_status_col d-flex align-items-end">
                                                    <button
                                                    className='sxi_primary_blue_btn btn-height'
                                                    style={{marginBottom: "2px", opacity: facebookSelectionUnchanged ? 0.5 : 1, cursor: facebookSelectionUnchanged ? 'not-allowed' : 'pointer'}}
                                                    disabled={facebookSelectionUnchanged}
                                                    onClick={handleFacebookSelectAccount}>
                                                        Select
                                                    </button>
                                                    <button
                                                    className='back-button btn-height mx-3'
                                                    style={{marginBottom: "2px"}}
                                                    onClick={handle_facebook_sign_out}
                                                    >
                                                    <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                    </button>
                                                </Col>
                                            </Row>
                                        }
                                        { show_facebook_login_btn === false && facebook_ads_account_select_dict.length === 0 &&
                                            <Row>
                                                <Col sm={8} className="d-flex align-items-center">
                                                    <span>No ads account found.</span>
                                                </Col>
                                                <Col sm={4} className="google_and_meta_integration_status_col">
                                                    <button
                                                    className='back-button btn-height'
                                                    onClick={handle_facebook_sign_out}
                                                    >
                                                    <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                    </button>
                                                </Col>
                                            </Row>
                                        }
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Step - 3 (Google Drive Integration) */}
                            {SHOW_DRIVE_INTEGRATION && (
                            <Accordion.Item eventKey="2">
                                <Accordion.Header className='google-ads-accordion-button'>
                                    <img src={number_3} alt='3' width={"15px"} height={"15px"} />
                                    <b style={{marginLeft:"10px"}}>Integrate Google Drive</b>
                                </Accordion.Header>
                                <Accordion.Body className='pt-2'>
                                    <Container className='google_and_meta_integration_accordion_container'>
                                        { drive_loading ?
                                            <Row className='mt-3'>
                                                <Col className='d-flex align-items-center justify-content-center'>
                                                    <Spinner animation="border" size="sm"/>
                                                </Col>
                                            </Row>
                                            :
                                            <Row className='mt-3'>
                                                { drive_connected !== true ?
                                                    <>
                                                    <Col className='d-flex align-items-center' sm={8}>Connect Google Drive to let your agents deliver reports and files to it.</Col>
                                                    <Col sm={4} className='google_and_meta_integration_status_col text-end'>
                                                        <button style={{backgroundColor:'var(--cux-btn, rgb(19, 40, 72))', color:"white", width:"8rem",border:"none","padding": "2px 10px 2px 2px","cursor":" pointer", display:"flex", alignItems:"center"}} onClick={handle_drive_sign_in}>
                                                            <svg style={{background:"white", padding:"6px", marginRight:"10px", flexShrink:0}} width={"30px"} height={"30px"} viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Google Drive">
                                                                <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"/>
                                                                <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47"/>
                                                                <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.5l5.85 11.5z" fill="#ea4335"/>
                                                                <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"/>
                                                                <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"/>
                                                                <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"/>
                                                            </svg>
                                                            <h6 style={{margin:"auto"}}>
                                                                Sign In
                                                            </h6>
                                                        </button>
                                                    </Col>
                                                    </>
                                                    :
                                                    <>
                                                    <Col className='d-flex align-items-center' sm={8}>
                                                        <img alt='connected' src={connected_icon} width={"22px"} style={{marginRight:"10px"}}/>
                                                        <span>Google Drive connected{drive_email ? <> as <b>{drive_email}</b></> : null}.</span>
                                                    </Col>
                                                    <Col sm={4} className="google_and_meta_integration_status_col d-flex align-items-center justify-content-end">
                                                        <button
                                                        className='back-button btn-height'
                                                        onClick={handle_drive_sign_out}
                                                        >
                                                        <span style={{margin:"auto",whiteSpace:"nowrap"}}>Sign Out</span>
                                                        </button>
                                                    </Col>
                                                    </>
                                                }
                                            </Row>
                                        }
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            )}
                        </Accordion>
                        </div>
                        </>
                        :
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border"/>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default Home